import { normalize, mapObjectToList } from '../utils';

const initialState = {
  loading: false,
  errors: {},
  data: {},
};

const regions = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'REGION_LIST_REQUEST':
      return {
        ...state,
        loading: true,
        data: {},
      };
    case 'REGION_LIST_SUCCESS':
      return {
        ...state,
        loading: false,
        data: Object.assign({}, state.data, normalize(payload)),
      };
    case 'REGION_LIST_FAILURE':
      return {
        ...state,
        loading: false,
        errors: payload.errors,
      };
    default:
      return state;
  }
};

export default regions;

export const regionsList = state => mapObjectToList(state.data);



// WEBPACK FOOTER //
// ./client/app/reducers/regions.js